import "./Report.scss";
import "./report.css";


import ReportPriority from "../../ReportPriority/ReportPriority";
import { useEffect, useState, useRef, Fragment } from "react";
import moment, { duration } from "moment";
import jsPDF from "jspdf";
import html2canvas from "@nidi/html2canvas";
import axios from "axios";
import { Toaster, toast } from "react-hot-toast";
import {
  PRIORITY_1_FIRST_PAGE,
  PRIORITY_1_ARRHYTHMIA,
  applyPriorityOrder,
} from "../../constants/constants";
// import "react-toastify/dist/ReactToastify.css";

import ReportHeader from "./../ReportHeader/ReportHeader";
import ReportFooter from "./../ReportFooter/ReportFooter";

import {
  ROOT_URI,
  API_ENDPOINT,
  FIRST_PAGE_IMAGE_PRIORITY,
  ARRYTHMIA_FOLDERS,
  API_ENDPOINT_V2,
  API_ENDPOINT_WEB,
  API_ENDPOINT_DATA,
} from "../../constants/constants";
import { DOCTORS, DEFAULT_DOCTOR_ID, NONE_DOCTOR_ID, SIGNED_COPY_DOCTOR_ID } from "../../constants/doctors";
import FirstPage from "./FirstPage";
import LastPage from "./LastPage";
import UncontrolledInput from "../UncontrolledInput/UncontrolledInput";
import getImageDimensions from "../../helpers/getImageDimensions";
import Table from "../Table/Table";
import Loader from "../Loader/Loader";
import getImageMeta from "../../helpers/getImageMeta";
import { saveAs } from "file-saver";
import DairyTable from "../Table/DairyTable";

const Report = () => {
  const [tableState, setTableState] = useState({
    heading: "",
    data: [],
  });
  const handlePriority1 = () => {
  // FIRST PAGE
  const sortedFirst = applyPriorityOrder(
    FIRST_PAGE_IMAGE_PRIORITY,
    PRIORITY_1_FIRST_PAGE
  );

  localStorage.setItem(
    "report_priority_first_page",
    JSON.stringify(sortedFirst)
  );

  // ARRYTHMIA
  const sortedArr = applyPriorityOrder(
    ARRYTHMIA_FOLDERS,
    PRIORITY_1_ARRHYTHMIA
  );

  localStorage.setItem(
    "report_priority_arrhythmia",
    JSON.stringify(sortedArr)
  );

  // 🔥 IMPORTANT → trigger refresh without reload
  window.dispatchEvent(new Event("priorityUpdated"));
};
  const [findings, setFindings] = useState("");
  const [reportDetails, setReportDetails] = useState({
    name: "",
    gender: "",
    age: "",
    duration: "",
    organization: "",
    referredBy: "",
    from: "",
    to: "",
    patientid: "",
    Indication: "",
    beats: "",
    pacemaker: false,
    atrial_ectopicsTotal: "",
    atrial_ectopicsIsolated: "",
    atrial_ectopicsCouplet: "",
    atrial_ectopicsLongest: "",
    atrial_ectopicsFastest: "",
    atrial_ectopicsTrigeminy: "",
    atrial_ectopicsBigeminy: "",
    ventricular_ectopicsTotal: "",
    ventricular_ectopicsIsolated: "",
    ventricular_ectopicsCouplet: "",
    ventricular_ectopicsLongest: "",
    ventricular_ectopicsFastest: "",
    ventricular_ectopicsTrigeminy: "",
    ventricular_ectopicsBigeminy: "",
    ventricular_ectopicsEpisodes: "",
    pausesInExcess: "",
    pausesIntwosec: "",
    maxPause: "",
    afibBurden: "",
    afibLongest: "",
    afibFastest: "",
  });

  const [report, setReport] = useState();
  const [userId, setUserId] = useState();
  const [pdfType, setPdfType] = useState("Full Report");
  const [loading, setLoading] = useState(false);

  const [uploading, setUploading] = useState(false);
  const [hospitalid, setHospitalid] = useState("");
  const reportRef = useRef();
  const [delTable, setDelTable] = useState("report__images-wrapper");
  const [delGraph, setDelGraph] = useState("report__hr-image");
  const [lorngePlotOneDel, setLorengePlotOneDel] = useState("report__plot");
  const [lorngePlotTwoDel, setLorengePlotTwoDel] = useState("report__plot");
  const [Treemenu, setTreemenu] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [fd, setFd] = useState(false);
  const [showPriorityEditor, setShowPriorityEditor] = useState(false);
  const [priorityOrder, setPriorityOrder] = useState([]);
  const [priorityOrderFirstPage, setPriorityOrderFirstPage] = useState([]);
  const [showQc, setShowQc] = useState(false);
  const [qcComments, setQcComments] = useState("");
  const [mailId, setMailId] = useState("");
  const [mailSubject, setMailSubject] = useState("");
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [mailInput, setMailInput] = useState("");
  const [mailTextarea, setMailTextarea] = useState("");
  const [whatsappInput, setWhatsappInput] = useState("");
  const [whatsappTextarea, setWhatsappTextarea] = useState("");
  const [formattedDateTime, setFormattedDateTime] = useState("");
  const [completionDate, setCompletionDate] = useState("");
  const [uncontrolledValues, setUncontrolledValues] = useState({});
  const uncontrolledInputRefs = useRef({});
  const [savedUncontrolledValues, setSavedUncontrolledValues] = useState({});

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [reportName, setReportName] = useState("");

  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [signatureFile, setSignatureFile] = useState(null);
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [selectedDoctorId, setSelectedDoctorId] = useState(DEFAULT_DOCTOR_ID);
  // When set (e.g. { enabled: true, doctorId }), forces the signature in the
  // rendered report for a one-off PDF capture (archived signed copy on publish).
  const [signatureOverride, setSignatureOverride] = useState(null);
  // Enable signature for all except SCTIMST
  const [signatureEnabled, setSignatureEnabled] = useState(() => {
    if (
      reportDetails.organization &&
      reportDetails.organization.trim().toUpperCase() === 'SCTIMST'
    ) {
      return false;
    }
    return true;
  });

  function reorderByPriority(arr, priority) {
  if (!priority.length) return arr;

  const orderMap = new Map(priority.map((p, i) => [p.key, i]));

  return [...arr].sort((a, b) => {
    const indexA = orderMap.has(a.key) ? orderMap.get(a.key) : Infinity;
    const indexB = orderMap.has(b.key) ? orderMap.get(b.key) : Infinity;

    return indexA - indexB;
  });
}

useEffect(() => {

  // 🔹 Arrhythmia priority
  const savedArr = localStorage.getItem("report_priority_arrhythmia");

  if (savedArr) {
    setPriorityOrder(JSON.parse(savedArr));
  }

  // 🔹 First Page priority
  const savedFirst = localStorage.getItem("report_priority_first_page");

  if (savedFirst) {
    setPriorityOrderFirstPage(JSON.parse(savedFirst));
  }

}, []);

useEffect(() => {
  const handlePriorityUpdate = () => {
    // Arrhythmia priority
    const savedArr = localStorage.getItem("report_priority_arrhythmia");
    if (savedArr) {
      setPriorityOrder(JSON.parse(savedArr));
    }

    // First page priority
    const savedFirst = localStorage.getItem("report_priority_first_page");
    if (savedFirst) {
      setPriorityOrderFirstPage(JSON.parse(savedFirst));
      // Re-sort report.images if present
      setReport((prevReport) => {
        if (!prevReport || !prevReport.images) return prevReport;
        const priority = JSON.parse(savedFirst);
        const orderMap = new Map(priority.map((p, i) => [p.key, i]));
        const sortedImages = [...prevReport.images].sort((a, b) => {
          const indexA = orderMap.has(a.key) ? orderMap.get(a.key) : Infinity;
          const indexB = orderMap.has(b.key) ? orderMap.get(b.key) : Infinity;
          return indexA - indexB;
        });
        return { ...prevReport, images: sortedImages };
      });
    }
  };
  window.addEventListener("priorityUpdated", handlePriorityUpdate);
  return () => {
    window.removeEventListener("priorityUpdated", handlePriorityUpdate);
  };
}, []);
const sortedArrythmiaFolders = reorderByPriority(
  ARRYTHMIA_FOLDERS,
  priorityOrder
);

const sortedFirstPage = reorderByPriority(
  FIRST_PAGE_IMAGE_PRIORITY,
  priorityOrderFirstPage
);


  // Resolve signatureEnabled from BOTH org policy and the saved preference.
  // - SCTIMST: always OFF (hard policy, overrides everything).
  // - Otherwise: use the saved __signatureEnabled if one was stored, else
  //   default ON. We no longer force ON for non-SCTIMST, so a manually
  //   disabled + saved signature stays disabled after reload.
  useEffect(() => {
    const org = (reportDetails.organization || "").trim().toUpperCase();
    if (org === "SCTIMST") {
      setSignatureEnabled(false);
      return;
    }
    if (savedUncontrolledValues.__signatureEnabled !== undefined) {
      setSignatureEnabled(savedUncontrolledValues.__signatureEnabled === "true");
    } else {
      setSignatureEnabled(true);
    }
  }, [reportDetails.organization, savedUncontrolledValues]);
  const [getdevice_id,setDevice_id]=useState("")

  // Move generatePDF function here, after setPdfType is defined
  const generatePDF = (type) => {
    setPdfType(type);
  };

  // Log device id whenever it changes
  useEffect(() => {
    if (getdevice_id) {
      console.log("device id !!!!!!!!!!!!", getdevice_id);
    }
  }, [getdevice_id]);

  const handleUncontrolledChange = (key, value) => {
    setUncontrolledValues((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };

  const handleFileDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    setSelectedFile(file);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleUploadClick = () => {
    setReportName(
      `Biocalculus_${report.name.replace(/\s+/g, "_")}_${report.device_id}`
    );
    console.log("report name", reportName);
    setShowUploadModal(true);
  };

  const closeUploadModal = () => {
    setShowUploadModal(false);
    setSelectedFile(null);
  };

  const handleFileUpload = async () => {
    if (selectedFile) {
      setUploading(true); // Set uploading to true
      try {
        const renamedFile = new File([selectedFile], `${reportName}.pdf`, {
          type: selectedFile.type,
        });

        const formData = new FormData();
        formData.append("pdf", renamedFile);
        formData.append("userid", userId); // Ensure userid is included

        const response = await axios.post(
          `${API_ENDPOINT}/patients/uploadreportpdf?userid=${userId}`,

          formData,

          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 200) {
          console.log("File uploaded successfully:");
        } else {
          toast.error("Failed to upload the file.");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error("An error occurred while uploading the file.");
      } finally {
        const response = await axios.post(
          `${API_ENDPOINT_DATA}/common/publish`,
          {
            user_id: userId,
          }
        );
        if (response && response.data) {
          toast.success("File uploaded successfully!");
        }
        setUploading(false); // Set uploading to false

        closeUploadModal();
      }
    } else {
      alert("Please select a file to upload.");
    }
  };

  const handleSignatureButtonClick = () => {
    setShowSignatureModal(true);
  };

  const handleSignatureFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "image/png") {
      setSignatureFile(file);
      setSignatureUrl(URL.createObjectURL(file));
    } else {
      alert("Please upload a PNG file.");
      setSignatureFile(null);
      setSignatureUrl(null);
    }
  };

  const closeSignatureModal = () => {
    setShowSignatureModal(false);
  };

  useEffect(() => {
    const userId = window.location.search.replace("?userid=", "");
    setUserId(userId);
    // setUserId("65cd9b7f84bfaa724c8f89b4");
  }, []);

  useEffect(() => {
    if (!userId) {
      return;
    }
    (async () => {
      try {
        let totalPages = 1;
        // Patient Details

        const imagesToShow = [];

        const [
          { data: patientDetails },
          { data: ecgDetails },
          { data: userSettings },
        ] = await Promise.all([
          axios.get(`${API_ENDPOINT}/patients/details?userid=${userId}`),
          axios.get(
            `${API_ENDPOINT}/common/getPatientTotalDetails?userid=${userId}`
          ),
          axios.get(`${API_ENDPOINT}/patients/settings?userid=${userId}`),
        ]);
        setDevice_id(patientDetails.device_id);
       
        const { data: doctorDetails } = await axios.get(
          `${API_ENDPOINT}/androidapi/getDoctorInfo?userid=${patientDetails.doctorid}`
        );

        const hospitalid = doctorDetails.database_id;
        setHospitalid(hospitalid);
        // console.log("hospital id !!!!!!!!!!!!", doctorDetails.address);
        const noOfArrythmiaImagesToUse = Number(userSettings.graph_gen);

        const {
          data: { children: directoryTree },
        } = await axios.get(
          `${API_ENDPOINT_V2}/common/patient_dir_new?userid=${userId}`
        );

        // get dairy data
        const { data: dairyData } = await axios.get(
          `${API_ENDPOINT}/patients/getDiary?userid=${userId}`
        );

        // get dairy data
        

        // Build imagesToShow from FIRST_PAGE_IMAGE_PRIORITY and user priority
       
        // Only include images that exist in directoryTree
        const availableKeys = directoryTree.map((d) => d.name);

        let sortedFirstPageImages = [...FIRST_PAGE_IMAGE_PRIORITY];

        if (priorityOrderFirstPage && priorityOrderFirstPage.length > 0) {
          sortedFirstPageImages = reorderByPriority(
            FIRST_PAGE_IMAGE_PRIORITY,
            priorityOrderFirstPage
          );
        }

        // filter available images
        sortedFirstPageImages = sortedFirstPageImages.filter(img =>
          availableKeys.includes(img.key)
        );
        imagesToShow.length = 0;
        sortedFirstPageImages.forEach(img => {
          imagesToShow.push({ key: img.key, name: img.name });
        });

        // For TABLE/HR Graphs
        const tableImages = [];
        const hrImages = [];

        Object.keys(ecgDetails).forEach((name) => {
          if (name.includes("table")) {
            tableImages.push(name);
            ecgDetails[name] = ecgDetails[name].replace(/'/gi, '"');
          }
        });

        directoryTree.forEach(({ name, extension }) => {
          if (name.includes("hr") && extension === ".png") {
            hrImages.push(name);
          }
        });

        // For arrythmia graphs
        
        
      const sortedArrythmiaFolders = reorderByPriority(
        ARRYTHMIA_FOLDERS,
        priorityOrder
      );

      
        const chosenArrythmias = [];

      for (let j = 0; j < sortedArrythmiaFolders.length; j++) {

        const arrythmia = directoryTree.find(
          ({ name }) => name === sortedArrythmiaFolders[j].key
        );

        if (arrythmia) {
          chosenArrythmias.push({
            ...arrythmia,
            heading: sortedArrythmiaFolders[j].name,
          });
        }
      }

        const arrythmiaImages = [];

        let showHeading = false;
        chosenArrythmias.forEach((chosenArrythmia) => {
          showHeading = true;
          if (
            chosenArrythmia.name === "max" ||
            chosenArrythmia.name === "min"
          ) {
            return arrythmiaImages.push({
              heading: chosenArrythmia.heading,
              showHeading: showHeading,
              url: `${ROOT_URI}/${patientDetails.device_id}/${chosenArrythmia.name}/cropped_image/max_${chosenArrythmia.name}.png`,
            });
          }
          const imageDirectories = chosenArrythmia.children[0].children.filter(
            ({ type }) => type === "directory"
          );

          imageDirectories.forEach((directory) => {
            directory.children.splice(noOfArrythmiaImagesToUse);

            directory.children.forEach(({ name }) => {
              arrythmiaImages.push({
                heading: chosenArrythmia.heading,
                showHeading: showHeading,
                url: `${ROOT_URI}/${patientDetails.device_id}/${chosenArrythmia.name}/cropped_image/${directory.name}/${name}`,
              });
              showHeading = false;
            });
          });
        });

        await Promise.all(
          arrythmiaImages.map(async (image, index) => {
            const { height, width } = await getImageMeta(image.url);
            const scaledHeight = (height / width) * 500;

            arrythmiaImages[index] = {
              ...image,
              height:
                scaledHeight -
                0.23 * scaledHeight +
                (image.showHeading ? 17 : 0),
            };
            return true;
          })
        );

        // PAUSES
        const sinuses = ecgDetails.sinus_pause.split(",");
        // console.log("sinuses~!!!!!!!!!!!!!!!!!",sinuses)
        // ATRIAL
        const pac = ecgDetails.pac.split(",");
        const afib = ecgDetails.afib.split(",");

        // VENTRIAL
        const pvc = ecgDetails.pvc.split(",");
        const vt = ecgDetails.vt.split(",");
        // console.log('ecgdetails!!!!!!!!!!!!!!',ecgDetails.pac)
        pac[0] = `${pac[0]}|${pac[1]}%`;
        pac[10] = `${pac[10]}%`;
        pac[11] = `${pac[11]}%`;

        afib[0] = `${afib[0]}|${afib[1]}%`;
        afib[2] = `${afib[2]}%`;

        pvc[0] = `${pvc[0]}|${pvc[1]}%`;
        pvc[10] = `${pvc[10]}%`;
        pvc[11] = `${pvc[11]}%`;

        // Separate date from pac 12 & 13
        let [pac12Value, pac12Date] = pac[12].split("@");
        let [pac13Value, pac13Date] = pac[13].split("@");

        // Format pac12Date and pac13Date
        pac12Date = pac12Date
          ? pac12Date.trim().match(/(\d{2}:\d{2}:\d{2})/)?.[0] +
            " " +
            pac12Date
              .trim()
              .match(/(\d{4}-\d{2}-\d{2})/)?.[0]
              .split("-")
              .slice(1)
              .reverse()
              .join("-")
          : "";
        pac13Date = pac13Date
          ? pac13Date.trim().match(/(\d{2}:\d{2}:\d{2})/)?.[0] +
            " " +
            pac13Date
              .trim()
              .match(/(\d{4}-\d{2}-\d{2})/)?.[0]
              .split("-")
              .slice(1)
              .reverse()
              .join("-")
          : "";

        // Assign values back to pac
        pac[12] = pac12Value;
        pac[13] = pac13Date;

        // Log the formatted dates
        // console.log("pac12Date:", pvc[12]);
        // console.log("pac13Date:", pvc[13]);

        const from = moment(new Date(ecgDetails.Data_from)).format(
          "YYYY/MM/DD@HH:mm"
        );

        const to = moment(new Date(ecgDetails.Data_to)).format(
          "YYYY/MM/DD@HH:mm"
        );
        const regex = /(<([^>]+)>)/gi;

        let foundImpression = false; // Flag to track if "IMPRESSION" section has started

        let longestRRValue = "";
        let longestRRTime = "";

        const parseLongestRR = (value) => {
          if (!value) return { value: "", timeText: "" };
          const parts = value.split("@");
          if (parts.length >= 2) {
            return {
              value: parts[0].trim(),
              timeText: parts.slice(1).join("@").trim(),
            };
          }
          const match = value.match(/([\d.]+\s*sec)\s*@\s*(.+)$/i);
          if (match) {
            return { value: match[1].trim(), timeText: match[2].trim() };
          }
          return { value: value.trim(), timeText: "" };
        };

        const extractLongestRRTimeOnly = (value = "") => {
          const timeMatch = value.match(/(\d{2}:\d{2}:\d{2})/);
          return timeMatch ? timeMatch[1] : value.trim();
        };

        const extractLongestRRDate = (value = "") => {
          const dateMatch = value.match(/(\d{4}-\d{2}-\d{2})/);
          if (dateMatch) return dateMatch[1];
          const altDateMatch = value.match(/(\d{2}-\d{2}-\d{4})/);
          return altDateMatch ? altDateMatch[1] : "";
        };

        const buildLongestRRFullValueFromItem = (item) => {
          if (!item) return "";
          const rawTime = item.time || "";
          const timeOnly = extractLongestRRTimeOnly(rawTime);
          const dateOnly = extractLongestRRDate(rawTime);
          const dateTime = dateOnly
            ? `${dateOnly} ${timeOnly || rawTime}`.trim()
            : (timeOnly || rawTime).trim();
          return `${item.rr_sec} sec @ ${dateTime}`.trim();
        };

        const pauseValue = ecgDetails.maxPause
          ? ecgDetails.maxPause
          : (() => {
              const pauseParts = ecgDetails.sinus_pause?.split(",") || [];
              return pauseParts[8]?.trim() || "";
            })();

        if (pauseValue) {
          const parsed = parseLongestRR(pauseValue);
          longestRRValue = parsed.value;
          longestRRTime = parsed.timeText;
        }

        const hasDateInLongestRR =
          /(\d{4}-\d{2}-\d{2})/.test(longestRRTime) ||
          /(\d{2}-\d{2}-\d{4})/.test(longestRRTime);

        if (longestRRTime && !hasDateInLongestRR && Array.isArray(ecgDetails.longest_rr)) {
          const selectedTimeOnly = extractLongestRRTimeOnly(longestRRTime);
          const selectedValue = longestRRValue.replace(/\s+/g, " ").trim();
          const matchingLongestRR = ecgDetails.longest_rr.find((item) => {
            const itemFullValue = buildLongestRRFullValueFromItem(item);
            const parsedItem = parseLongestRR(itemFullValue);
            const itemTimeOnly = extractLongestRRTimeOnly(parsedItem.timeText);
            return (
              parsedItem.value.replace(/\s+/g, " ").trim() === selectedValue &&
              itemTimeOnly === selectedTimeOnly
            );
          });

          if (matchingLongestRR) {
            const parsedMatch = parseLongestRR(
              buildLongestRRFullValueFromItem(matchingLongestRR)
            );
            longestRRTime = parsedMatch.timeText;
          }
        }

        ecgDetails.findings = ecgDetails.findings
          .replace("<br>", "")
          .replace("</br>", "")
          .replace("approximately ", "")
          .replace(regex, "")
          .split(". ")
          .map((val) => {
            const trimmedVal = val.trim();
            const upperVal = trimmedVal.toUpperCase();
            
            // console.log(trimmedVal)
            // Check if the line starts the "IMPRESSION" section
            if (upperVal.startsWith("IMPRESSION:")) {
              foundImpression = true; // Set flag when "IMPRESSION" starts
              return `${trimmedVal}`; // Return "IMPRESSION" with bold formatting
            }

            // Keep Longest RR sentence intact
            console.log("🧪 RAW FINDINGS STRING >>>", JSON.stringify(trimmedVal));
            if (
            trimmedVal.toLowerCase().includes("longest rr interval noted") &&
            longestRRValue
          ) {
            const timeText = longestRRTime ? ` on ${longestRRTime}` : "";
            return `# Longest RR interval noted was ${longestRRValue}${timeText}`;
          }


            // Exclude the specific sentence about pauses
            if (
              trimmedVal.includes(
                "Pauses greater than 2 seconds was 0 ( 0 % of total analysed beats)"
              )
            ) {
              return ""; // Skip this sentence
            }
            if (dairyData.length != 0) {
              if (trimmedVal.includes("No Triggered Event Noted")) {
                return ""; // Return empty string if "No Triggered Event Noted" is found
              }
            }

            // If we're in the "IMPRESSION" section, don't add "#"
            if (foundImpression) {
              return trimmedVal; // Return the line as-is without adding #
            }

            // Add # if not already present and we're not in the "IMPRESSION" section
            return trimmedVal.startsWith("#") ? trimmedVal : `# ${trimmedVal}`;
          })
          .filter((val) => val) // Remove empty lines (like the skipped sentence)
          .join(". \n");

        // Ensure that findings start with proper formatting (indentation) if it does not start with #
        if (!ecgDetails.findings.trim().startsWith("#")) {
          ecgDetails.findings = "  " + ecgDetails.findings;
        }

        // console.log("findings!!!!!", ecgDetails.findings);

        ecgDetails.duration = ecgDetails.duration.split(":");
        ecgDetails.duration.splice(3);
        ecgDetails.duration = ecgDetails.duration.join(" ");
        ecgDetails.duration = ecgDetails.duration.replace("d", " Day");

        setReport({
        ...ecgDetails,
        doctorName:
          patientDetails.updatedDotorName === "NA"
            ? doctorDetails.name
            : patientDetails.updatedDotorName,
        ...patientDetails,
        age: moment(new Date()).diff(
          moment(new Date(patientDetails.dob)).format("YYYY/MM/DD"),
          "years"
        ),
        pausesInExcess: `${sinuses[7]}`,
        pausesIntwosec: sinuses[0],
        maxPause: sinuses[8],
        afib,
        pvc,
        pac,
        vt,
        images: [...imagesToShow],        // 🔥 ensure new reference
        tableImages: [...tableImages],    // 🔥 safe
        hrImages: [...hrImages],          // 🔥 safe
        arrythmiaImages: [...arrythmiaImages], // 🔥 IMPORTANT FIX
        totalPages,
        from,
        to,
        pac12Date,
        pac13Date,
        dairyData,
      });

      // Mirror patient-level fields from the API into reportDetails so handleSave
      // doesn't post empty values when the verifier hasn't manually edited them.
      // Preserves any user edits via the prev spread (only fills empty slots).
      const computedAge = moment(new Date()).diff(
        moment(new Date(patientDetails.dob)).format("YYYY/MM/DD"),
        "years"
      );
      const resolvedDoctorName =
        patientDetails.updatedDotorName === "NA"
          ? doctorDetails.name
          : patientDetails.updatedDotorName;
      setReportDetails((prev) => ({
        ...prev,
        name:         prev.name         || patientDetails.name         || "",
        gender:       prev.gender       || patientDetails.gender       || "",
        age:          prev.age          || computedAge                  || "",
        Indication:   prev.Indication   || patientDetails.Indication   || patientDetails.indication   || "",
        pacemaker:    prev.pacemaker    ?? patientDetails.pacemaker    ?? false,
        organization: prev.organization || patientDetails.organization || patientDetails.Organization || "",
        Organization: prev.Organization || patientDetails.Organization || patientDetails.organization || "",
        doctorName:   prev.doctorName   || resolvedDoctorName           || "",
        duration:     prev.duration     || ecgDetails.duration          || "",
        beats:        prev.beats        || ecgDetails.total_beatscount || ecgDetails.analyzed_beats || "",
      }));
      } catch (err) {
        console.log(err);
        setReport({});
      }
    })();
  }, [userId,priorityOrder]);

  useEffect(() => {
    if (!userId) return;

    const fetchSavedUncontrolledValues = async () => {
      try {
        const response = await axios.get(
          `${API_ENDPOINT}/users/getUncontrolledValues?userid=${userId}`
        );
        const data = response.data || {};
        setSavedUncontrolledValues(data);
        // Restore the previously saved signature doctor so a refresh keeps
        // the signature instead of resetting to "No Signature".
        if (data.__signatureDoctorId) {
          setSelectedDoctorId(data.__signatureDoctorId);
        }
      } catch (error) {
        console.error(
          "Error fetching saved uncontrolled values:",
          error.message
        );
      }
    };

    fetchSavedUncontrolledValues();
  }, [userId]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey && event.key === "z") || event.key === "Z") {
        // Check if Control and "a" are pressed together
        // const axios=
      }
    };

    // Add event listener when component mounts
    window.addEventListener("keydown", handleKeyDown);

    // Clean up event listener when component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Empty dependency array means this effect runs once on mount and cleanup on unmount

  if (!report) {
    return "Loading...";
  }

  if (Object.keys(report).length === 0) {
    return "USER NOT FOUND";
  }

  const handleChange = (e) => {
    const newReport = { ...report };
    newReport[e.target.name] = e.target.value;
    setReport(newReport);
  };
  const handleAddTable = (e) => {
    console.log("loading !!!!!!!!!!!!!!!");
  };
  const handleReportDetailsChange = (updatedDetails) => {
    setReportDetails((prevDetails) => ({
      ...prevDetails,
      ...updatedDetails,
    }));
    console.log("report details:", reportDetails);
  };
  const handleFindingsChange = (newFindings) => {
    // Function to structure the findings
    const structuredFindings = (text) => {
      return text
        .split("\n") // Split by lines
        .map((line) => line.replace(/^#\s*/, "").trim()) // Remove '#' and leading/trailing spaces
        .filter((line) => line.length > 0) // Exclude empty lines
        .join(" "); // Combine lines into a single sentence
    };

    // Process the newFindings input
    const formattedFindings = structuredFindings(newFindings);

    // Update the state
    setFindings(formattedFindings);
    setReport((prevReport) => ({
      ...prevReport,
      findings: newFindings,
    }));

    // Log the changes
    console.log("Formatted Findings:", findings);
  };

  const handleDurationChange = (e) => {
    const newReport = { ...report };
    newReport.duration[e.target.name] = e.target.value;
    setReport(newReport);
    console.log("value!!!!!!!!!!!!!!!!!!!!!:", e.target.value);
  };

  const handleArrayChange = (key, index) => (e) => {
    const newReport = { ...report };
    report[key][index] = e.target.value;
    setReport(newReport);
  };

  const handleImageDelete = (index) => {
    const newSetOfArrythmiaImages = [...report.arrythmiaImages];

    const arrythmia = newSetOfArrythmiaImages[index];
    console.log("index!!!!!!!!!!!!!!!!!!", index);
    console.log(arrythmia.url);

    const response = axios.post(
      `${API_ENDPOINT_V2}/common/removereportfile/`,
      { userid: arrythmia.url }
    );

    if (arrythmia.showHeading) {
      if (
        newSetOfArrythmiaImages[index + 1] &&
        !newSetOfArrythmiaImages[index + 1].showHeading
      ) {
        newSetOfArrythmiaImages[index + 1].showHeading = true;
        newSetOfArrythmiaImages[index + 1].height =
          newSetOfArrythmiaImages[index + 1].height + 17;
      }
    }
    newSetOfArrythmiaImages.splice(index, 1);
    setReport({ ...report, arrythmiaImages: newSetOfArrythmiaImages });
  };
  const handleCommentChange = (event) => {
    const updatedComment = event.target.value
      .replace(/Approved/g, "")
      .replace(/Rejected/g, "");

    setQcComments(updatedComment);
  };

  const handelTableDelete = () => {};

  // Refactored getPdf to accept forceSignature parameter
  const getPdf = async (forceSignature = null) => {
    window.scrollTo(0, 0);
    const reportContainer = document.querySelector(".report__content");
    const pages = reportContainer.childNodes;
    const totalPDFPages = pages.length;
    const scale = 2;
    const IMAGE_WIDTH = 595;
    const IMAGE_HEIGHT = 841;
    let images = Array(totalPDFPages).fill(null);

    // --- Use local variables for signature state ---
    const selectedDoctor = DOCTORS.find((d) => d.id === selectedDoctorId);
    let useSignature = signatureEnabled && !!selectedDoctor;
    let useSignatureUrl = signatureUrl;
    if (!useSignatureUrl && selectedDoctor) {
      useSignatureUrl = selectedDoctor.signature;
    }
    if (forceSignature !== null) {
      useSignature = forceSignature;
    }

    // The PDF rendering logic should use useSignature and useSignatureUrl
    // (If you have conditional rendering in the report, pass these as props or context)

    images = await Promise.all(
      images.map(async (_, index) => {
        const node = pages[index];
        const canvas = await html2canvas(node, {
          allowTaint: true,
          useCORS: true,
          scale: index === 0 ? scale * 2 : scale,
          width: IMAGE_WIDTH,
          height: IMAGE_HEIGHT,
        });
        canvas.getContext("2d");
        const image = canvas.toDataURL("image/jpeg", 0.6);
        return image;
      })
    );

    const { w, h } = await getImageDimensions(images[0]);
    const pdf = new jsPDF("p", "px", [w, h], false);
    pdf.addImage(images[0], "jpeg", -8 * 2 * scale, 0, w, h);
    for (var i = 1; i < totalPDFPages; i++) {
      pdf.addPage();
      pdf.addImage(images[i], "jpeg", -8 * 2 * scale, 0, w, h);
    }
    return pdf;
  };

  const handlePdfDownload = async () => {
    setLoading(true);
    try {
      await axios.put(`${API_ENDPOINT}/patients/updateReportStatus`, {
        patientId: userId,
      });

      // Save before PDF generation
      await handleSave();

      const safePatientName = (report.name || "")
        .replace(/%20/g, "_")
        .replace(/\s+/g, "_");

      // Prepare file names
      const baseFileName = `Biocalculus_${report.name}_${report.device_id}_${pdfType
        .split(" ")
        .join("_")}`;
      const downloadFileName = `Biocalculus_${report.name}_${report.device_id}.pdf`;
      const withSignatureFileName = `${baseFileName}_with_signature.pdf`;
      const withoutSignatureFileName = `${baseFileName}_without_signature.pdf`;

      const makePdfBlob = async (pdfDoc) => {
        // ArrayBuffer avoids some edge-cases with blob typing / partial data.
        const ab = await pdfDoc.output("arraybuffer");
        return new Blob([ab], { type: "application/pdf" });
      };

      const toUploadForm = (pdfBlob, fileName) => {
        const file = new File([pdfBlob], fileName, { type: "application/pdf" });
        const form = new FormData();
        form.append("file", file);
        form.append("type", pdfType);
        return form;
      };

      const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

      const uploadWithRetry = async (url, formData) => {
        const maxAttempts = 4;
        let lastErr = null;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          try {
            return await axios.post(url, formData, {
              // Slow networks can take time; don't timeout client-side.
              timeout: 0,
              // Large PDF uploads: avoid Axios body/content limits.
              maxBodyLength: Infinity,
              maxContentLength: Infinity,
              headers: { "Content-Type": "multipart/form-data" },
            });
          } catch (err) {
            lastErr = err;

            const status = err?.response?.status;
            const isNetworkError = !err?.response;
            const shouldRetry =
              isNetworkError || status === 408 || status === 429 || (status >= 500 && status < 600);

            if (!shouldRetry || attempt === maxAttempts) break;

            // Exponential backoff: 1s, 2s, 4s...
            await sleep(1000 * Math.pow(2, attempt - 1));
          }
        }

        throw lastErr;
      };

      const assertBlobOk = (pdfBlob) => {
        // A real report should never be tiny; tiny blobs often indicate a failed render.
        if (!pdfBlob || pdfBlob.size < 10 * 1024) {
          throw new Error(`PDF blob too small (${pdfBlob?.size || 0} bytes)`);
        }
      };

      if (!signatureEnabled) {
        // Download without signature; upload both without + with signature
        const withSignaturePdf = await getPdf(true);
        const withoutSignaturePdf = await getPdf(false);

        const withSignatureBlob = await makePdfBlob(withSignaturePdf);
        const withoutSignatureBlob = await makePdfBlob(withoutSignaturePdf);

        assertBlobOk(withSignatureBlob);
        assertBlobOk(withoutSignatureBlob);

        // Download EXACT bytes we upload (unsigned)
        saveAs(withoutSignatureBlob, downloadFileName);

        await uploadWithRetry(
          `${API_ENDPOINT_V2}/common/patientpdfuploadNew_path?userid=${userId}&Pat_Name=${safePatientName}&device_id=${report.device_id}`,
          toUploadForm(withoutSignatureBlob, withoutSignatureFileName)
        );

        await uploadWithRetry(
          `${API_ENDPOINT_V2}/common/patientpdfuploadNew_path-1?userid=${userId}&Pat_Name=${safePatientName}&device_id=${report.device_id}`,
          toUploadForm(withSignatureBlob, withSignatureFileName)
        );

        toast.success("Both files uploaded successfully");
      } else {
        // Download + upload with signature only
        const withSignaturePdf = await getPdf(true);
        const withSignatureBlob = await makePdfBlob(withSignaturePdf);
        assertBlobOk(withSignatureBlob);

        // Download EXACT bytes we upload (signed)
        saveAs(withSignatureBlob, downloadFileName);

        await uploadWithRetry(
          `${API_ENDPOINT_V2}/common/patientpdfuploadNew_path?userid=${userId}&Pat_Name=${safePatientName}&device_id=${report.device_id}`,
          toUploadForm(withSignatureBlob, withSignatureFileName)
        );

        toast.success("File (with signature) uploaded successfully");
      }
    } catch (err) {
      console.error("PDF download/upload error:", err);
      toast.error("Failed to generate/upload PDF. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (updatedTableState) => {
    setTableState(updatedTableState);
  };
  const handleSave = async () => {
    try {
      console.log("Uncontrolled Values:", uncontrolledValues);

      // Log the current values of all uncontrolled inputs
      const editedUncontrolledValues = {};
      Object.keys(uncontrolledInputRefs.current).forEach((key) => {
        const ref = uncontrolledInputRefs.current[key];
        if (ref) {
          const value = ref.getValue();
          console.log(`Uncontrolled Input [${key}]:`, value);
          editedUncontrolledValues[key] = value;
        }
      });

      // Persist which doctor's signature was used. This is separate from the
      // patient's registered doctor and was never stored before. Reserved keys
      // (double-underscore) so they never collide with an input heading. Read
      // back on load so the signature stays after a refresh, and available in
      // the DB for the future verify-dashboard feature.
      const sigDoctor = DOCTORS.find((d) => d.id === selectedDoctorId);
      editedUncontrolledValues["__signatureDoctorId"] = selectedDoctorId;
      editedUncontrolledValues["__signatureDoctorName"] = sigDoctor ? sigDoctor.name : "";
      // Persist the on/off toggle too, so a disabled signature stays disabled
      // after a reload (not just the doctor choice).
      editedUncontrolledValues["__signatureEnabled"] = signatureEnabled ? "true" : "false";

      // API call to save uncontrolled values
      if (Object.keys(editedUncontrolledValues).length > 0) {
        try {
          const response = await axios.post(
            `${API_ENDPOINT}/users/saveUncontrolledValues`,
            {
              userid: userId,
              uncontrolledValues: editedUncontrolledValues,
            }
          );
          console.log("Uncontrolled values saved successfully:", response.data);
          // toast.success("!");
          setSavedUncontrolledValues(editedUncontrolledValues); // Update local state
        } catch (error) {
          console.error(
            "Error saving uncontrolled values:",
            error.response?.data || error.message
          );
          toast.error("Failed to save uncontrolled values.");
        }
      }

      toast.success("Saved Successfully!");
      // Extract table and findings data
      const tableData = JSON.stringify(tableState);
      const findingsData = findings;
      // Split and log heading and data
      console.log("Heading:", tableState.heading);
      console.log("Data:", tableState.data);
      // Extract patient details
      const userid = userId;
      const editedPatient = reportDetails;
      const patient_name = editedPatient.name;
      const gender = editedPatient.gender;
      const age = editedPatient.age;
      // const analysed_beats = editedPatient.analysed_beats;
      const indication = editedPatient.Indication;
      const pacemaker = editedPatient.pacemaker;

      console.log("Edited Patient Details:", report);

      // Update editing
      const updateEditing = async () => {
        try {
          // Prepare the payload
          const payload = {
            userid: userid,
            name: patient_name,
            gender: gender,
            age: age,
            analyzed_beats: reportDetails.beats,
            indication: indication,
            pacemaker: pacemaker,
            updatedDotorName: reportDetails.doctorName,
            hospital: reportDetails.Organization || report.hospital,
            duration:reportDetails.duration,

          };
          console.log("duration",reportDetails.duration) 

          // Make the POST request
          const response = await axios.post(
            `${API_ENDPOINT}/common/update_patient_report_details`,
            payload, // Pass the payload in the request body
            {
              headers: {
                "Content-Type": "application/json", // Ensure JSON content type
              },
            }
          );

          // Backend returns { message, data: { modifiedCount, ... } } on success.
          // Treat HTTP 2xx + non-zero modifiedCount as success.
          const ok =
            response.status >= 200 &&
            response.status < 300 &&
            (response.data?.data?.modifiedCount ?? 1) !== 0;
          if (ok) {
            console.log("Update successful:", response.data.message || response.data);
            toast.success("Patient details updated successfully.");
          } else {
            console.warn("Update returned non-success:", response.status, response.data);
          }
        } catch (error) {
          console.error(
            "Error in updateEditing API call:",
            error.response?.data || error.message
          );
        }
      };

      // Execute updateEditing first
      await updateEditing();

      // Modularized API call handler
      const postData = async (url, data, description) => {
        try {
          const response = await axios.post(url, data);
          console.log(`${description} Response:`, response.data);
        } catch (error) {
          console.error(
            `Error in ${description} API call:`,
            error.response?.data || error.message
          );
        }
      };

      // Post to `update_totals` — skip if the table has nothing to save, so the
      // backend doesn't reject the call with "Missing userid, heading, or data".
      const hasTableData =
        userId &&
        tableState &&
        tableState.heading &&
        Array.isArray(tableState.data) &&
        tableState.data.length > 0;
      if (hasTableData) {
        await postData(
          `${API_ENDPOINT}/users/TableUpdate`,
          {
            userid: userId,
            heading: tableState.heading,
            data: tableState.data,
          },
          "TableUpdate"
        );
      }

      // Post to `update_findings` — skip if empty, same reason.
      if (userid && findingsData) {
        await postData(
          `${API_ENDPOINT}/users/UpdateFindings`,
          {
            userid,
            findings: findingsData,
          },
          "UpdateFindings"
        );
      }
      const [atrialEctopicsTotal, atrialEctopicsSecond] = (reportDetails.atrial_ectopicsTotal || "|").replace("%", "").split("|");
      const [ventricular_ectopicsTotal, ventricular_ectopicsSecond] = (reportDetails.ventricular_ectopicsTotal || "|").replace("%", "").split("|");
      const [afibBurden, afibBurdenSecond] = (reportDetails.afibBurden || "|").replace("%", "").split("|");

      console.log("Atrial Ectopics Total:", atrialEctopicsTotal.trim());
      console.log("Atrial Ectopics Second:", atrialEctopicsSecond.trim());

      const reportFields = {
        userid: userId,
        atrial_ectopicsTotal: (atrialEctopicsTotal || "").trim(),
        atrial_ectopicsSecond: (atrialEctopicsSecond || "").trim(),
        atrial_ectopicsIsolated: (reportDetails.atrial_ectopicsIsolated || "").replace("%", ""),
        atrial_ectopicsCouplet: (reportDetails.atrial_ectopicsCouplet || "").replace("%", ""),
        atrial_ectopicsLongest: (reportDetails.atrial_ectopicsLongest || "").replace("%", ""),
        atrial_ectopicsFastest: (reportDetails.atrial_ectopicsFastest || "").replace("%", ""),
        atrial_ectopicsTrigeminy: (reportDetails.atrial_ectopicsTrigeminy || "").replace("%", ""),
        atrial_ectopicsBigeminy: (reportDetails.atrial_ectopicsBigeminy || "").replace("%", ""),
        ventricular_ectopicsTotal: (ventricular_ectopicsTotal || "").trim(),
        ventricular_ectopicsSecond: (ventricular_ectopicsSecond || "").trim(),
        ventricular_ectopicsIsolated: (reportDetails.ventricular_ectopicsIsolated || "").replace("%", ""),
        ventricular_ectopicsCouplet: (reportDetails.ventricular_ectopicsCouplet || "").replace("%", ""),
        ventricular_ectopicsLongest: (reportDetails.ventricular_ectopicsLongest || "").replace("%", ""),
        ventricular_ectopicsFastest: (reportDetails.ventricular_ectopicsFastest || "").replace("%", ""),
        ventricular_ectopicsTrigeminy: (reportDetails.ventricular_ectopicsTrigeminy || "").replace("%", ""),
        ventricular_ectopicsBigeminy: (reportDetails.ventricular_ectopicsBigeminy || "").replace("%", ""),
        ventricular_ectopicsEpisodes: (reportDetails.ventricular_ectopicsEpisodes || "").replace("%", ""),
        pausesInExcess: (reportDetails.pausesInExcess || "").replace("%", ""),
        pausesIntwosec: (reportDetails.pausesIntwosec || "").replace("%", ""),
        maxPause: (reportDetails.maxPause || "").replace("%", ""),
        afibBurden: (afibBurden || "").trim(),
        afibBurdenSecond: (afibBurdenSecond || "").trim(),
        afibLongest: (reportDetails.afibLongest || "").replace("%", ""),
        afibFastest: (reportDetails.afibFastest || "").replace("%", ""),
      };

      // Filter out empty values
      const nonEmptyFields = Object.values(reportFields).filter(
        (value) => value !== "" && value !== null && value !== undefined
      );

      // If all fields are empty, do not call the API
      if (nonEmptyFields.length === 0) {
        console.log("All fields are empty. API call aborted.");
        return;
      }

      // If only 1 field has a value, also prevent the call
      if (nonEmptyFields.length < 2) {
        console.log("Less than two fields have values. API call aborted.");
        return;
      }

      // Make API call if at least 2 fields have values
      await axios.post(
        `${API_ENDPOINT}/common/updateReportDetails`,
        reportFields
      );
    } catch (error) {
      console.error("Error in handleSave:", error.message);
    }
  };
  const showQCModal = async () => {
    const response = await axios.get(
      `${API_ENDPOINT}/patients/GetQcDetails?userid=${userId}`
      
    );

    const comments = response.data.comments
      ? `${response.data.comments} ${
          response.data.QC !== undefined && response.data.QC !== null
            ? response.data.QC === true
              ? "Approved"
              : "Rejected"
            : ""
        }`
      : response.data.QC !== undefined && response.data.QC !== null
      ? response.data.QC === true
        ? "Approved"
        : "Rejected"
      : "";

    // This ensures that "Approved" or "Rejected" is only shown if QC has a value

    setQcComments(comments);
    console.log("Qc repsonse:!!!!!!!", response.data);

    setShowQc(true);
  };
  const submitComment = async (e) => {
    const userid = userId;
    const comments = qcComments;

    try {
      const response = await axios.post(
        `${API_ENDPOINT}/patients/addComment/${userid}`,
        { comments }
      );
      // console.log('Response:', response.data);

      setQcComments("");
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };
  // Wait for React to flush a state change into the DOM before html2canvas runs.
  const waitForRender = () =>
    new Promise((resolve) =>
      requestAnimationFrame(() => requestAnimationFrame(resolve))
    );

  // When an UNSIGNED report is published, archive a SIGNED copy using the fixed
  // default doctor (Dr. Prajjal Kumar Sinha). Uploaded to the secondary slot
  // (patientpdfuploadNew_path-1 → Biocalculus1_...pdf). Never shared — kept for
  // the future verify-dashboard. Failures here never block publishing.
  const archiveSignedCopy = async () => {
    try {
      setSignatureOverride({ enabled: true, doctorId: SIGNED_COPY_DOCTOR_ID });
      await waitForRender();

      const signedPdf = await getPdf();

      // Restore the on-screen (unsigned) state immediately after capture.
      setSignatureOverride(null);
      await waitForRender();

      const ab = await signedPdf.output("arraybuffer");
      const signedBlob = new Blob([ab], { type: "application/pdf" });
      if (!signedBlob || signedBlob.size < 10 * 1024) {
        throw new Error(`Signed copy too small (${signedBlob?.size || 0} bytes)`);
      }

      const safePatientName = (report.name || "")
        .replace(/%20/g, "_")
        .replace(/\s+/g, "_");
      const baseFileName = `Biocalculus_${report.name}_${report.device_id}_${pdfType
        .split(" ")
        .join("_")}`;
      const signedFileName = `${baseFileName}_with_signature.pdf`;

      const file = new File([signedBlob], signedFileName, { type: "application/pdf" });
      const form = new FormData();
      form.append("file", file);
      form.append("type", pdfType);

      await axios.post(
        `${API_ENDPOINT_V2}/common/patientpdfuploadNew_path-1?userid=${userId}&Pat_Name=${safePatientName}&device_id=${report.device_id}`,
        form,
        {
          timeout: 0,
          maxBodyLength: Infinity,
          maxContentLength: Infinity,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log("Signed archive copy uploaded successfully.");
    } catch (err) {
      setSignatureOverride(null); // ensure UI is restored even on failure
      console.error("Failed to archive signed copy:", err);
    }
  };

  const HandlePublish = async () => {
    if (report.QC == true) {
      toast.success("Publishing................");
      try {
        // If publishing an UNSIGNED report, keep a signed archive copy first.
        const isPublishingUnsigned =
          !signatureEnabled || !DOCTORS.find((d) => d.id === selectedDoctorId);
        if (isPublishingUnsigned) {
          await archiveSignedCopy();
        }

        const response = await axios.post(
          `${API_ENDPOINT}/common/publish_new`,
          {
            user_id: userId,
          }
        );

        if (response && response.data) {
          const Priority =
            (report.deviceInfo && report.deviceInfo.Priority) || 4;
          let finalTime;

          if (report.ConfirmupdatedDate) {
            let confirmButtonTime = report.ConfirmupdatedDate.split("T");
            let confirmDate = confirmButtonTime[0];
            let confirmTime = confirmButtonTime[1]
              ? confirmButtonTime[1].split("Z")[0]
              : "";
            if (confirmTime) {
              let time = confirmTime.split(".")[0];
              finalTime = confirmDate + " " + time;
            }
          }

          if (report.updatedDate && !finalTime) {
            let updatedDateTime = report.updatedDate.split(" ");
            let updatedDate = updatedDateTime[0];
            let updatedTime = updatedDateTime[1];
            finalTime = updatedDate + " " + updatedTime;
          }

          const now = new Date();
          const finalDate = new Date(finalTime);
          const timeDifference = now - finalDate;
          const hoursDifference = timeDifference / (1000 * 60 * 60);

          let timeLimit;
          switch (Priority) {
            case 1:
              timeLimit = 1;
              break;
            case 2:
              timeLimit = 2;
              break;
            case 3:
              timeLimit = 3;
              break;
            case 4:
              timeLimit = 4;
              break;
            case 5:
              timeLimit = 5;
              break;
            default:
              timeLimit = 4;
          }

          const timeLimitHours = timeLimit * report.exp_device_use_days;
          let timePercentage = (hoursDifference / timeLimitHours) * 100;
          if (timePercentage > 100) timePercentage = 100;

          const completionRate = timePercentage / hoursDifference;
          const totalCompletionTime = 100 / completionRate;
          const remainingTimeInHours = totalCompletionTime - hoursDifference;
          const remainingTimeInMilliseconds =
            remainingTimeInHours * 60 * 60 * 1000;
          let completionDate = new Date(
            now.getTime() + remainingTimeInMilliseconds
          );

          // Adjust completion date to ensure it's at least 2 minutes after now
          const twoMinutesLater = new Date(now.getTime() + 15 * 60 * 1000);
          if (completionDate < twoMinutesLater) {
            completionDate = twoMinutesLater;
          }

          const adjustedCompletionDate = new Date(
            completionDate.getTime() - 30 * 60 * 1000
          );
          const formattedCompletionDate = `${adjustedCompletionDate.getFullYear()}-${(
            adjustedCompletionDate.getMonth() + 1
          )
            .toString()
            .padStart(2, "0")}-${adjustedCompletionDate
            .getDate()
            .toString()
            .padStart(2, "0")} ${adjustedCompletionDate
            .getHours()
            .toString()
            .padStart(2, "0")}:${adjustedCompletionDate
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;

          const mailId = await axios.get(
            `${API_ENDPOINT_DATA}/users/getMailidSchedule/${report.device_id}000000000`,
            {
              userID: userId,
            }
          );
          setMailId(mailId.data.mailid);
          setWhatsappInput(mailId.data.whatsapp);
          setMailSubject(`${report.name} Biocalculus: ${report.device_id}`);
          console.log("mail id", mailId.data.deviceInfo.mail);
          console.log("whatsapp", mailId.data.deviceInfo.whatsapp);
          console.log(`${report.name} Biocalculus: ${report.device_id}`);
          const nowTime = new Date();
          const formattedCompletionDateTime = new Date(formattedCompletionDate);

          let adjustedTime;
          if (formattedCompletionDateTime <= nowTime) {
            adjustedTime = new Date(nowTime.getTime() + 15 * 60 * 1000);
          } else {
            adjustedTime = formattedCompletionDateTime;
          }
          console.log(
            "Adjusted Completion Date:",
            `${adjustedTime.getFullYear()}-${(adjustedTime.getMonth() + 1)
              .toString()
              .padStart(2, "0")}-${adjustedTime
              .getDate()
              .toString()
              .padStart(2, "0")} ${adjustedTime
              .getHours()
              .toString()
              .padStart(2, "0")}:${adjustedTime
              .getMinutes()
              .toString()
              .padStart(2, "0")}`
          );
          console.log("userid", userId);

          await axios.post(
            `${API_ENDPOINT}/common/schedulecron`,
            {
              mailid: mailId.data.deviceInfo.mail,

              mailsubject: `${report.name} Biocalculus: ${report.device_id}`,
              scheduledTime: `${adjustedTime.getFullYear()}-${(
                adjustedTime.getMonth() + 1
              )
                .toString()
                .padStart(2, "0")}-${adjustedTime
                .getDate()
                .toString()
                .padStart(2, "0")} ${adjustedTime
                .getHours()
                .toString()
                .padStart(2, "0")}:${adjustedTime
                .getMinutes()
                .toString()
                .padStart(2, "0")}`,
              userid: userId,
              number: mailId.data.deviceInfo.whatsapp,
            }
          );

          // Add Mail and whatsapp sharing logic here

          toast.success("Published successfully!");
          toast.success(
            "Mail scheduled for:" +
              `${adjustedTime.getFullYear()}-${(adjustedTime.getMonth() + 1)
                .toString()
                .padStart(2, "0")}-${adjustedTime
                .getDate()
                .toString()
                .padStart(2, "0")} ${adjustedTime
                .getHours()
                .toString()
                .padStart(2, "0")}:${adjustedTime
                .getMinutes()
                .toString()
                .padStart(2, "0")}`,
            { duration: 5000 }
          );
        } else {
          toast.error("Unexpected response from the server.");
        }
      } catch (err) {
        console.error("Error storing blob:", err);
        toast.error("Failed to publish.");
      }
    } else {
      toast.error("QC Not Approved.");
    }
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const closePublishModal = () => {
    setShowPublishModal(false);
  };
  const scheduleMail = async () => {
    setShowPublishModal(false);
    console.log("report!!!!!!!!!!!!!!!!!!!!", report);
    try {
      if (report.QC == true) {
        const mailResponse = await axios.post(
          `${API_ENDPOINT_DATA}/users/sendmailReport_new_new_Read_Schedule`,
          {
            userid: userId,
            mailid: mailId,
            mailsubject: mailSubject,
            scheduledTime: completionDate,
            // completion_date: formatDate(completionDate)
          }
        );
        toast.success("Mail Scheduled successfully!");

        const whatsappResponse = await axios.post(
          `${API_ENDPOINT_DATA}/common/schedule_whatsapp`,
          {
            user_id: userId,
            arrythymia: whatsappTextarea || "NA",
            number: whatsappInput,
            scheduledTime: completionDate,
          }
        );

        toast.success("WhatsApp Scheduled successfully!");
        console.log("Mail Scheduled:", mailResponse.data);
        console.log("WhatsApp Scheduled:", whatsappResponse.data);
      } else {
        toast.error("QC Not Approved.");
      }
    } catch (err) {
      toast.error("Error in mail scheduling.");
      console.log("Error in mail scheduling:", err);
    }
  };

  const QcAccepted = async () => {
    await axios.put(
      `${API_ENDPOINT}/patients/updateqc/${userId}/1`
    );
    await axios.put(`${API_ENDPOINT_WEB}/patients/updateqc/${userId}/1`);

    console.log("confirm updated time ", report);

    setShowQc(false);
    submitComment();
  };
  const QcRejected = async () => {
    axios.put(
      `${API_ENDPOINT}/patients/updateqc/${userId}/0`
    );
    axios.put(`${API_ENDPOINT_WEB}/patients/updateqc/${userId/0}`);

    await axios.post(
      `${API_ENDPOINT_DATA}/common/skype_message`,
      {
        user_id: report.device_id,
      }
    );

    console.log("qc rejected");
    setShowQc(false);
    submitComment();
  };
  const GenerateTreemenu = async () => {
    try {
      // Make the API call
      const response = await axios.get(
        `${API_ENDPOINT_DATA}/common/patinentmenutreeNew?userid=${userId}`
      );

      const treemenu = response.data;
      let optionnewon = []; // For ascending order
      let optionnewendon = []; // For descending order

      // Iterate over each date group in treemenu
      Object.keys(treemenu).forEach((dateKey) => {
        treemenu[dateKey].forEach((entry) => {
          const MainTimeon = entry.date.split("T");
          const timeon = MainTimeon[1].split("+")[0]; // Extract time portion, ignoring timezone

          // Create the formatted time string: "date time"
          const timeStr = `${dateKey} ${timeon}`;

          // Push to both arrays
          optionnewon.push(timeStr);
          optionnewendon.push(timeStr);
        });
      });

      // Sort optionnewon (ascending order) by full date-time
      optionnewon.sort((a, b) => {
        const fullDateA = new Date(a); // Convert full date-time string to Date object
        const fullDateB = new Date(b); // Convert full date-time string to Date object
        return fullDateA - fullDateB; // Ascending order: compare full date-time
      });

      // Sort optionnewendon (descending order) by full date-time
      optionnewendon.sort((a, b) => {
        const fullDateA = new Date(a); // Convert full date-time string to Date object
        const fullDateB = new Date(b); // Convert full date-time string to Date object
        return fullDateB - fullDateA; // Descending order: compare full date-time
      });

      // Output the results
      // console.log('Sorted Ascending:', optionnewon);

      setTreemenu(optionnewendon);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const GenerateFullDisclosure = async () => {
    setFd(true); // Show loading state or some indication of processing
    setShowModal(false); // Close the modal
    try {
      await axios.post(
        `${API_ENDPOINT}/users/fullDisclosurePdf`,{
          userid:userId,
          startdate:startTime,
          enddate:endTime
        }
      );
    } catch (err) {
      console.log("error!!!!!!!!", err); // Log the error
    } finally {
      setFd(false); // Set the loading state to false after the request completes

      // Delay the download by 5 seconds (5000 milliseconds)
      setTimeout(() => {
        Download(); // Call the Download function after a 5-second delay
      }, 5000); // 5000 milliseconds = 5 seconds
    }
  };
  const Download = () => {
    const downloadUrl = `${API_ENDPOINT_DATA}/users/download?userid=${userId}`;

    axios({
      url: downloadUrl,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        console.log("response");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${userId}.pdf`);

        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
        toast.success("FD Downloaded Successfully!");
      })
      .catch((err) => {
        console.error("Download Error:", err);
      });
  };

  const handleSavePDFToServer = async () => {
    setUploading(true);

    const pdf = await getPdf();

    const output = await pdf.output("blob");

    const file = new File(
      [output],
      `Biocalculus_${report.name}_${report.device_id}_${pdfType
        .split(" ")
        .join("_")}.pdf`
    );

    const form = new FormData();

    form.append("file", file);
    form.append("type", pdfType);

    const article = { userid: "React POST Request Example" };
    await axios.post(`${API_ENDPOINT_V2}/common/patientpdfuploadNew_path`, article);
    setUploading(false);
  };
  const handleDoubleClick = async (index) => {
    const element = document.querySelector(`.report_images-wrapper${index}`);
    if (element) {
      element.style.display = "none"; // Set display to none to hide the element
    }
    console.log("report_images-wrapper", element);
  };

  // Example of binding the event (adjust according to your actual elements)
  document.querySelectorAll(".report_images-wrapper").forEach((el, index) => {
    el.addEventListener("dblclick", () => handleDoubleClick(index));
  });
  const handleReport_plotclick = async () => {
    const element = document.querySelector(`.report__plots`);
    if (element) {
      element.style.display = "none";
    }
    // console.log('report__plots clicked')
  };

  const formatDate = (date) => {
    let dd = String(date.getDate()).padStart(2, "0");
    let mm = String(date.getMonth() + 1).padStart(2, "0");
    let yyyy = date.getFullYear();
    let hrs = String(date.getHours()).padStart(2, "0");
    let min = String(date.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}T${hrs}:${min}`;
  };

  const parseDate = (dateString) => {
    const [datePart, timePart] = dateString.split("T");
    const [yyyy, mm, dd] = datePart.split("-");
    const [hrs, min] = timePart.split(":");
    return new Date(`${yyyy}-${mm}-${dd}T${hrs}:${min}`);
  };

  const handlePublishClick = async () => {
    try {
      const Priority = (report.deviceInfo && report.deviceInfo.Priority) || 4;
      let finalTime;

      if (report.ConfirmupdatedDate) {
        let confirmButtonTime = report.ConfirmupdatedDate.split("T");
        let confirmDate = confirmButtonTime[0];
        let confirmTime = confirmButtonTime[1]
          ? confirmButtonTime[1].split("Z")[0]
          : "";
        if (confirmTime) {
          let time = confirmTime.split(".")[0];
          finalTime = confirmDate + " " + time;
        }
      }

      if (report.updatedDate && !finalTime) {
        let updatedDateTime = report.updatedDate.split(" ");
        let updatedDate = updatedDateTime[0];
        let updatedTime = updatedDateTime[1];
        finalTime = updatedDate + " " + updatedTime;
      }

      const now = new Date();
      const finalDate = new Date(finalTime);
      const timeDifference = now - finalDate;
      const hoursDifference = timeDifference / (1000 * 60 * 60);

      let timeLimit;
      switch (Priority) {
        case 1:
          timeLimit = 1;
          break;
        case 2:
          timeLimit = 2;
          break;
        case 3:
          timeLimit = 3;
          break;
        case 4:
          timeLimit = 4;
          break;
        case 5:
          timeLimit = 5;
          break;
        default:
          timeLimit = 4;
      }

      const timeLimitHours = timeLimit * report.exp_device_use_days;
      let timePercentage = (hoursDifference / timeLimitHours) * 100;
      if (timePercentage > 100) timePercentage = 100;

      const completionRate = timePercentage / hoursDifference;
      const totalCompletionTime = 100 / completionRate;
      const remainingTimeInHours = totalCompletionTime - hoursDifference;
      const remainingTimeInMilliseconds = remainingTimeInHours * 60 * 60 * 1000;
      const completionDate = new Date(
        now.getTime() + remainingTimeInMilliseconds
      );

      setCompletionDate(formatDate(completionDate));

      const mailId = await axios.get(
        `${API_ENDPOINT_DATA}/users/getMailidSchedule/${report.device_id}000000000`,
        {
          userID: userId,
        }
      );
      console.log("mail id", mailId.data);
      setMailId(mailId.data.deviceInfo.mail);
      setWhatsappInput(mailId.data.deviceInfo.whatsapp);
      setMailSubject(`${report.name} Biocalculus: ${report.device_id}`);
      if (report.QC == true) {
        setShowPublishModal(true);
      } else {
        toast.error("QC Not Approved.");
      }
    } catch (err) {
      console.log("error!!!!!!!!", err); // Log the error
    }
  };

  const imageBlocks = report.tableImages.reduce(
    (acc, val, index) => {
      const totalSize = acc[acc.length - 1].reduce(
        (acc, val) => acc + val.size,
        0
      );
      console.log("index!!!!!!!!!", index);
      const data = report[val];
      const size = (JSON.parse(data).length - 1) * 10.4 + 29.6 + 14;
      if (size + 80 + totalSize > 755) {
        acc.push([]);
      }

      acc[acc.length - 1].push({
        jsx: (
          <Fragment key={val}>
            <div
              className={`report_images-wrapper${index}`}
              key={index}
              onDoubleClick={() => handleDoubleClick(index)}
            >
              <Table data={data} onTableChange={handleTableChange} />
            </div>
          </Fragment>
        ),
        size,
      });
      acc[acc.length - 1].push({
        jsx: (
          <div
            className={`report__hr-image${index}`}
            key={val.replace("table", "hr")}
            onDoubleClick={() => {
              handleDoubleImgClick(index);
            }}
          >
            <img
              className="report__hr-image"
              src={`${ROOT_URI}/${getdevice_id}/${report.hrImages[index]}`}
              alt=""
            />
          </div>
        ),
        size: 80,
      });

      return acc;
    },
    [[]]
  );
  const handleDoubleImgClick = async (index) => {
    const element = document.querySelector(`.report__hr-image${index}`);
    if (element) {
      element.style.display = "none"; // Set display to none to hide the element
    }
    console.log("report__hr-image", element);
  };

  // Example of binding the event (adjust according to your actual elements)
  document.querySelectorAll(".report__hr-image").forEach((el, index) => {
    el.addEventListener("dblclick", () => handleDoubleClick(index));
  });

  const totalSize = imageBlocks[imageBlocks.length - 1].reduce(
    (acc, val) => acc + val.size,
    0
  );

  if (totalSize + 183 > 755) {
    imageBlocks.push([]);
  }

  const lastImageBlockIndex = imageBlocks.length - 1;

  imageBlocks[lastImageBlockIndex].push({
    jsx: (
      <div className="report__images-wrapper" key="PLOT I">
        <div
          className="report__plots"
          onDoubleClick={() => {
            handleReport_plotclick();
          }}
        >
          <div className="report__plot">
            <p className="report__plot-title">ACTIVITY vs TIME</p>
            <img
              className="report__plot-graph"
              src={`${ROOT_URI}/${getdevice_id}/activity_time_plot.png`}
              alt=""
            />
          </div>
          <div className="report__plot">
            <p className="report__plot-title">ACTIVITY vs ARRHYTHMIA</p>
            <img
              className="report__plot-graph"
              src={`${ROOT_URI}/${getdevice_id}/activity_arr_plot.png`}
              alt=""
            />
          </div>
        </div>
      </div>
    ),
    size: 183,
  });

  let lastBlockPageTotalLength = imageBlocks[lastImageBlockIndex].reduce(
    (acc, val) => acc + val.size,
    0
  );

  let addedNewPage = false;

  if (lastBlockPageTotalLength + 175 > 755) {
    addedNewPage = true;
    imageBlocks.push([]);
  }

  imageBlocks[imageBlocks.length - 1].push({
    jsx: (
      <div
        className="report__images-wrapper"
        key="PLOT II"
        style={{ marginTop: !addedNewPage && "-35px" }}
      >
        <div className="report__plots">
          <div
            className={lorngePlotOneDel}
            onDoubleClick={() => {
              setLorengePlotOneDel("report__plot-onedel");
            }}
          >
            <p className="report__plot-title">Lorenz Plot - All Beats</p>
            <img
              className="report__plot-chart"
              src={`${ROOT_URI}/${getdevice_id}/lorentz_allbeats.png`}
              alt=""
            />
          </div>
          <div
            className={lorngePlotTwoDel}
            onDoubleClick={() => {
              setLorengePlotTwoDel("report__plot-twodel");
            }}
          >
            <p className="report__plot-title">Lorenz Plot - Normal Beats</p>
            <img
              className="report__plot-chart"
              src={`${ROOT_URI}/${getdevice_id}/lorentz_normalbeats.png`}
              alt=""
            />
          </div>
        </div>
      </div>
    ),
    size: addedNewPage ? 210 : 175,
  });
  if (report.dairyData && report.dairyData.length) {
    const totalSize1 = imageBlocks[imageBlocks.length - 1].reduce(
      (acc, val) => acc + val.size,
      0
    );
    if (totalSize1 + 183 > 755) {
      imageBlocks.push([]);
    }
    imageBlocks[imageBlocks.length - 1].push({
      jsx: <DairyTable key={"DAIRY_TABLE"} data={report.dairyData} />,
      size: addedNewPage ? 210 : 175,
    });
  }

  let arrythmiaImagesPerPage;
  let totalPages;

  if (pdfType === "Full Report") {
    let arrythmiaImages = [...report.arrythmiaImages];

    let spaceRemainingInPreviousPage =
      755 -
      imageBlocks[imageBlocks.length - 1].reduce(
        (acc, val) => acc + val.size,
        0
      );

    let items = 0;
    let heightsOfNewImages = 0;
    for (const item in arrythmiaImages) {
      const image = arrythmiaImages[item];
      if (heightsOfNewImages + image.height > spaceRemainingInPreviousPage) {
        items = item;
        break;
      }
      heightsOfNewImages += image.height;
    }

    const splittedArrythmiaImages = arrythmiaImages.splice(0, items);

    splittedArrythmiaImages.forEach(({ url, heading, showHeading }, index) => {
      imageBlocks[imageBlocks.length - 1].push({
        jsx: (
          <Fragment key={url}>
            {showHeading && <UncontrolledInput initialValue={heading} />}
            <div className="report__images-wrapper">
              <img
                onDoubleClick={() => handleImageDelete(index)}
                key={url}
                className="report__arrythmia-images"
                src={url}
                alt={report.arrythmiaImages.label}
              />
            </div>
          </Fragment>
        ),
      });
    });

    arrythmiaImagesPerPage = arrythmiaImages.reduce(
      (acc, val, index) => {
        const remainingSpace = acc[acc.length - 1].reduce((acc, val) => {
          return acc + val.height;
        }, 0);

        if (remainingSpace + val.height > 755) {
          acc.push([]);
        }

        acc[acc.length - 1].push({
          ...val,
          index: index + splittedArrythmiaImages.length,
        });

        return acc;
      },
      [[]]
    );

    totalPages = 1 + imageBlocks.length + arrythmiaImagesPerPage.length + 1;
  } else {
    totalPages = 1 + imageBlocks.length;
  }

  return (
    <>
      {" "}
      <div className="report">
        <div className="report__buttons">
          <button
            className="report__button"
            onClick={
              pdfType === "Full Report"
                ? handlePdfDownload
                : () => generatePDF("Full Report")
            }
          >
            {pdfType === "Full Report" ? (
              loading ? (
                <>
                  Building PDF ! <Loader />
                </>
              ) : (
                "Download Full Report"
              )
            ) : (
              "Generate Full Report"
            )}
          </button>
          {/* <button
          className="report__button"
          onClick={
            pdfType === "Patient Report"
              ? handlePdfDownload
              : () => generatePDF("Patient Report")
          }
        >
          {pdfType === "Patient Report" ? (
            loading ? (
              <>
                Building PDF ! <Loader />
              </>
            ) : (
              "Download Patient Report"
            )
          ) : (
            "Generate Patient Report"
          )}
        </button> */}
          <button className="report__button" onClick={GenerateTreemenu}>
            Generate FULL DISCLOSURE {fd && <Loader />}
          </button>
          <button onClick={handleSave} className="report__button">
            SAVE
          </button>{" "}
          <button className="report__button" onClick={showQCModal}>
            QC
          </button>
          <button className="report__button" onClick={HandlePublish}>
            Publish
          </button>
          <button className="report__button" onClick={handlePublishClick}>
            Schedule Report
          </button>
          <button className="report__button" onClick={handleUploadClick}>
            Upload Report
          </button>
          <button
            className="report__button"
            onClick={handleSignatureButtonClick}
          >
            Upload Signature
          </button>
          <button
            className="report__button"
            onClick={() => setSignatureEnabled((s) => !s)}
          >
            {signatureEnabled ? "Disable Signature" : "Enable Signature"}
          </button>
          <select
            className="report__button"
            value={selectedDoctorId}
            onChange={(e) => setSelectedDoctorId(e.target.value)}
            style={{ padding: "6px" }}
            title="Select preparing doctor"
          >
            <option value={NONE_DOCTOR_ID}>No Signature</option>
            {DOCTORS.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>
          <button
            className="report__button"
            onClick={() => setShowPriorityEditor(!showPriorityEditor)}
          >
            Edit Priority
          </button>
        </div>
        <div className="report__content" ref={reportRef}>
          <FirstPage
            {...{
              report,
              handleChange,
              handleDurationChange,
              handleArrayChange,
              totalPages,
              userId,
            }}
            onFindingsChange={handleFindingsChange}
            onReportDetailsChange={handleReportDetailsChange}
            signatureUrl={signatureUrl}
            signatureEnabled={signatureEnabled}
            doctorId={selectedDoctorId}
            signatureOverride={signatureOverride}
          />

          {imageBlocks.map((blocks, index) => (
            <div className="report__page" key={`IMAGE BLOCKS - ${index}`}>
              <ReportHeader
                patientId={
                  report.ip_op && report.ip_op !== "NA"
                    ? `MRD NO:${report.ip_op}`
                    : report.device_id
                }
                age={report.age}
                name={report.name}
              />
              <div className="report__page-wrapper">
                {blocks.map(({ jsx }) => jsx)}
              </div>
              <ReportFooter page={2 + index} totalPage={totalPages} />
            </div>
          ))}

          {/* ARRYTHMIA PAGES */}
          {arrythmiaImagesPerPage &&
            arrythmiaImagesPerPage.map((images, index) => (
              <div className="report__page" key={`arrythmia ${index}`}>
                <ReportHeader
                  patientId={
                    report.ip_op && report.ip_op !== "NA"
                      ? `MRD No:${report.ip_op}`
                      : report.device_id
                  }
                  age={report.age}
                  name={report.name}
                />
                <div className="report__page-wrapper report__arrythmia-pages-wrapper">
                  {images.map(
                    ({ url, heading, showHeading, index, height }) => (
                      <Fragment key={url}>
                        {showHeading && (
                          <UncontrolledInput
                            ref={(el) =>
                              (uncontrolledInputRefs.current[url] = el)
                            }
                            initialValue={heading}
                            savedValue={savedUncontrolledValues[url]} // Use saved value if available
                            inputKey={url}
                            onChange={handleUncontrolledChange}
                          />
                        )}
                        <div className="report__images-wrapper">
                          <img
                            onDoubleClick={() => handleImageDelete(index)}
                            className="report__arrythmia-images"
                            style={{
                              height: showHeading ? height - 17 : height,
                            }}
                            src={url}
                            alt={report.arrythmiaImages.label}
                          />
                        </div>
                      </Fragment>
                    )
                  )}
                </div>
                <ReportFooter
                  page={1 + imageBlocks.length + index + 1}
                  totalPage={totalPages}
                />
              </div>
            ))}
          {pdfType === "Full Report" && (
            <LastPage report={report} totalPages={totalPages} />
          )}
        </div>
        {showPriorityEditor && <ReportPriority onClose={() => setShowPriorityEditor(false)} />}
      </div>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Select Time Range</h3>
            <form>
              <div style={{ display: "flex", paddingLeft: "40px" }}>
                <div>
                  <label htmlFor="startTime">Start Time</label>
                  <select
                    id="startTime"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                  >
                    <option value="">Select Start Time</option>
                    {Treemenu.map((time, index) => (
                      <option key={index} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label htmlFor="endTime">End Time</label>
                  <select
                    id="endTime"
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                  >
                    <option value="">Select End Time</option>
                    {Treemenu.map((time, index) => (
                      <option key={index} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="modal-actions">
                <button type="button" onClick={closeModal}>
                  Close
                </button>{" "}
                <button type="button" onClick={GenerateFullDisclosure}>
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showQc && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            // Close the modal only if the click is outside the modal
            if (e.target.classList.contains("modal-overlay")) {
              setShowQc(false);
            }
          }}
        >
          <div className="modal">
            <h3>Quality Check</h3>
            <form>
              <div style={{ display: "flex", paddingLeft: "40px" }}>
                <div>
                  <textarea
                    name="qc"
                    className="qc-textarea"
                    id={userId}
                    value={qcComments} // The textarea will reflect the state value
                    onChange={handleCommentChange} // Handle changes in the textarea
                  />
                </div>
              </div>

              <div className="modal-actions">
                <button
                  style={{ backgroundColor: "#dd4e4e" }}
                  type="button"
                  onClick={QcRejected}
                >
                  Reject
                </button>
                <button
                  type="button"
                  style={{ backgroundColor: "#48983a" }}
                  onClick={QcAccepted}
                >
                  Accept
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showPublishModal && (
        <div className="modal-overlay">
          <div className="modal show-publish-modal">
            <h3>Share Report</h3>
            <form>
              <div className="mail-section">
                <h4>Share via Mail</h4>
                <label htmlFor="mailInput">Mail ID:</label>
                <input
                  id="mailInput"
                  type="email"
                  value={mailId}
                  onChange={(e) => setMailId(e.target.value)}
                />
                <label htmlFor="mailTextarea">Mail Subject:</label>
                <textarea
                  id="mailTextarea"
                  value={mailSubject}
                  onChange={(e) => setMailSubject(e.target.value)}
                />
              </div>
              <div className="whatsapp-section">
                <h4>Share via WhatsApp</h4>
                <label htmlFor="whatsappInput">WhatsApp Number:</label>
                <input
                  id="whatsappInput"
                  type="tel"
                  value={whatsappInput}
                  onChange={(e) => setWhatsappInput(e.target.value)}
                />
                <label htmlFor="whatsappTextarea">WhatsApp Message:</label>
                <textarea
                  id="whatsappTextarea"
                  value={whatsappTextarea}
                  onChange={(e) => setWhatsappTextarea(e.target.value)}
                />
              </div>
              <div className="completion-date-section">
                <label htmlFor="completionDate">Schedule Report:</label>
                <input
                  id="completionDate"
                  type="datetime-local"
                  value={completionDate}
                  onChange={(e) => setCompletionDate(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
              <div className="modal-actions">
                <button type="button" onClick={closePublishModal}>
                  Close
                </button>
                <button type="button" onClick={scheduleMail}>
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showUploadModal && (
        <div className="modal-overlay">
          <div
            className="modal"
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleFileDrop}
          >
            <h3>Upload Report</h3>
            <div
              style={{
                border: "2px dashed #ccc",
                padding: "20px",
                textAlign: "center",
                marginBottom: "20px",
                position: "relative",
                backgroundColor: uploading ? "rgba(0, 0, 0, 0.1)" : "white",
                pointerEvents: uploading ? "none" : "auto",
              }}
            >
              {uploading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    zIndex: 1,
                  }}
                >
                  <div
                    style={{
                      border: "4px solid #ccc",
                      borderTop: "4px solid #007bff",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      animation: "spin 1s linear infinite",
                    }}
                  ></div>
                </div>
              )}
              <p>Drag and drop a file here</p>
              <p>or</p>
              <input
                type="file"
                onChange={handleFileChange}
                style={{ display: "block", margin: "0 auto" }}
                disabled={uploading}
              />
            </div>
            {selectedFile && <p>Selected File: {selectedFile.name}</p>}
            <div className="modal-actions">
              <button
                type="button"
                onClick={closeUploadModal}
                disabled={uploading}
              >
                Close
              </button>
              <button
                type="button"
                onClick={handleFileUpload}
                disabled={uploading}
              >
                Upload
              </button>
            </div>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        </div>
      )}
      {showSignatureModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Upload Signature (PNG only)</h3>
            <input
              type="file"
              accept="image/png"
              onChange={handleSignatureFileChange}
            />
            {signatureUrl && (
              <div style={{ marginTop: "10px" }}>
                <img
                  src={signatureUrl}
                  alt="Signature Preview"
                  style={{
                    maxWidth: "200px",
                    maxHeight: "80px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            )}
            <div className="modal-actions">
              <button type="button" onClick={closeSignatureModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      <Toaster />
    </>
  );
};

export default Report;
